exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/main/pages/free-hotel-changes/free-hotel-modal/free-hotel-modal.component.scss
// module id = ../../../../../src/app/main/pages/free-hotel-changes/free-hotel-modal/free-hotel-modal.component.scss
// module chunks = main